import { createClient } from '@supabase/supabase-js'

// Fallback configuration for development
const fallbackConfig = {
  supabaseUrl: 'https://xhosfhnebhogpacxaktq.supabase.co',
  supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhob3NmaG5lYmhvZ3BhY3hha3RxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDEyMjk1MzcsImV4cCI6MjA1NjgwNTUzN30.N_mY_d7nglxpB0KaBr5grAVrArkR92PuOSv-4XEMN8w'
};

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || fallbackConfig.supabaseUrl;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || fallbackConfig.supabaseKey;

// Log a warning if using fallback values (only in development)
if (import.meta.env.DEV && !import.meta.env.VITE_SUPABASE_URL) {
  console.warn('Using fallback Supabase configuration. Set up environment variables for better security.');
}

export const supabase = createClient(supabaseUrl, supabaseKey); 